<template>
  <div class="x_box A4">
    <div class="x_body">
      <div class="print-header font-m">
        <h2 class="text-center" style="font-weight: bold;">{{company.Name}}</h2>
        <div style="font-size: 14px;">
          <b>{{$t('address')}} </b>
          {{$t('home_no')}} {{company.Home}} {{$t('village')}} {{company.Village}} {{$t('commune')}} {{company.Commune}} {{$t('district')}} {{company.District}} {{$t('capital')}} {{company.Capital}}
        </div>
        <div style="font-size: 14px;">
          <b>{{$t('phone')}}</b>
          {{company.Phone}}{{company.Email}}
        </div>
      </div>
      <h3 class="text-center font-m" style="font-weight: bold;">{{$t('invoice')}}</h3>
      <div class="row">
        <div class="col-sm-6">
          <table class="table-print">
            <tbody>
              <tr>
                <td style="width: 100px;">{{ $t('vendor') }}</td>
                <td style="width: 15px;">:</td>
                <td>{{invoice.VendorName}}</td>
              </tr>
              <tr>
                <td>{{$t('contact')}}</td>
                <td style="width: 15px;">:</td>
                <td>{{invoice.Contact}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-sm-6">
          <table class="table-print" align="right">
            <tbody>
              <tr>
                <td style="width: 100px;">{{$t('invoice_no')}}</td>
                <td style="width: 15px;">:</td>
                <td>{{invoice.Num}}</td>
              </tr>
              <tr>
                <td>{{$t('date')}}</td>
                <td>:</td>
                <td>{{$format(invoice.Date, 'DD/MM/YYYY')}}</td>
              </tr>
              <tr>
                <td>{{$t('due_date')}}</td>
                <td>:</td>
                <td>{{$format(invoice.DueDate, 'DD/MM/YYYY')}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <br/>
      <div class="row">
        <div class="col-sm-12">
          <table class="table table-bordered table-sm no-bor">
            <thead>
              <tr>
                <th class="text-center" style="width: 50px;">{{$t('no')}}</th>
                <th>{{$t('item_name')}}</th>
                <th class="text-center" style="width: 100px;">{{$t('qty')}}</th>
                <th class="text-right" style="width: 100px;">{{$t('price')}}</th>
                <th class="text-center" style="width: 100px;">{{$t('uom')}}</th>
                <th class="text-right" style="width: 100px;">{{$t('discount')}}(%)</th>
                <th class="text-right" style="width: 100px;">សរុប</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(ret,index) in lines" :key="ret.Id">
                <td class="text-center">{{index+1}}</td>
                <td>{{ret.ItemName}}</td>
                <td class="text-center">{{ret.Quantity}}</td>
                <td class="text-right">{{ret.Price}}</td>
                <td class="text-center">{{ret.UomName}}</td>
                <td class="text-right">{{ret.Discount}}</td>
                <td class="text-right">{{$money(ret.SubTotal)}}</td>
              </tr>
              <tr>
                <th colspan="3" rowspan="4" class="none-left none-bottom">&nbsp;</th>
                <td colspan="3" class="text-right">{{$t('grand_total')}}:</td>
                <td class="text-right">{{$money(invoice.GrandTotal)}}</td>
              </tr>
              <tr>
                <td colspan="3" class="text-right">{{$t('discount')}}:</td>
                <td class="text-right">{{$money(invoice.Discount)}}</td>
              </tr>
              <tr>
                <td colspan="3" class="text-right">{{$t('deposit')}}:</td>
                <td class="text-right">{{$money(invoice.Deposit)}}</td>
              </tr>
              <tr>
                <td colspan="3" class="text-right">{{$t('pay_amount')}}:</td>
                <td class="text-right">{{$money(invoice.PaidAmount)}}</td>
              </tr>
              <!--<tr>
                <th colspan="6" class="text-right">{{$t('grand_total')}}:</th>
                <th class="text-right">{{$money(invoice.GrandTotal)}}</th>
              </tr>-->
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="print-footer">
        <span>ល័ក្ខខ័ណ្ឌ</span>
      <p class="text-right">{{$now().format('ថ្ងៃទី DD ខែ MM ឆ្នាំ YYYY')}}</p>
      <div class="font-m" style="display: flex; justify-content: space-between;">
        <div style="padding: 0 25px;">អ្នកទិញ Buyer</div>
        <div style="padding: 0 25px;">អ្នកលក់ Seller</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: function() {
    return {
      company: {},
      invoice: {},
      lines: []
    };
  },
  created: function() {
    this.getCompany();
    let id = this.$route.params.id;
    if (id !== undefined && id !== null && id !== "") {
      let loading = this.$loading.show();
      this.$api()
        .post('po/invoice/find', { Id: id })
        .then(res => {
          var data = res.data.Data;
          this.invoice = data.POInvoice;
          this.lines = data.POInvoiceLines;
        })
        .finally(function() {
          loading.hide();
        });
    }
  },
  methods: {
    getCompany: function() {
      this.$api()
        .post("company")
        .then(res => {
          this.company = res.data.Data;
        });
    }
  }
};
</script>
<style scoped>
body {
  font-size: 14px;
}
</style>